<template>
  <div>
    <div
      v-if="forgetShow"
      class="forgetImg"
      :style="{ backgroundImage: `url('${forgetImg}')` }"
      @touchmove.prevent
    >
      <img class="close" :src="closeImg" alt="" @click="forgetShow = false" />
      <p class="jumpGame service_text color_link" @click="onGoService">未解决问题？点击咨询客服</p>
    </div>
    <div v-if="accountShow" class="wrapper" @touchmove.prevent>
      <div class="content">
        <div class="top">游戏账号绑定</div>
        <div class="mid">
          <Field
            v-show="validType === 0"
            v-model="acc"
            label="游戏账号"
            :error="errorFields.includes('acc')"
            placeholder="请输入游戏账号"
          />
          <Field
            v-show="validType === 0"
            v-model="pass"
            label="游戏密码"
            :type="passType === 0 ? 'password' : 'text'"
            :right-icon="passType === 0 ? 'closed-eye' : 'eye-o'"
            :error="errorFields.includes('pass')"
            placeholder="请输入游戏密码"
            @click-right-icon="changePasswordType"
          />
          <Field
            v-show="validType === 1"
            v-model="mobile"
            label="绑定手机号"
            maxlength="11"
            :error="errorFields.includes('mobile')"
            placeholder="请输入手机号"
          />
          <Field
            v-show="validType === 1"
            v-model="code"
            label="短信验证码"
            maxlength="6"
            :error="errorFields.includes('code')"
            placeholder="请输入验证码"
          >
            <template #button>
              <van-button
                class="code-btn"
                size="mini"
                :disabled="codeTimer !== 0 || sendCodeLoading"
                @click.stop="onSendValidCode"
              >
                {{ codeTimer === 0 ? '获取' : `${codeTimer}s` }}
              </van-button>
            </template>
          </Field>
        </div>
        <div class="extra_fn flex_between">
          <p class="switch_type mr_6" @click="changeValidType">
            切换至{{ validType === 0 ? '手机短信' : '账号密码' }}验证
          </p>
          <p v-show="validType === 0" @click="onShowForget">忘记账号密码</p>
        </div>
        <div class="submit" :class="{ disabled: submitLoading }" @click="onSubmit">
          {{ submitLoading ? '绑定中...' : '绑定游戏账号' }}
        </div>
        <p class="jumpGame" @click="jumpGame">没有游戏账号？点击前往下载游戏</p>
      </div>
      <!-- <img class="close" :src="closeImg" alt="" @click="onClose" /> -->
    </div>
  </div>
</template>

<script>
import { CDN_URL } from '@/config/index.js';
import { Field, Toast, Button } from 'vant';
import {
  bindActivityLandingAccount,
  bindActivityLandingMobile,
  sendActivityLandingMobileCode,
} from '@/api/activityLanding';
import {
  ACTIVITY_LANDING_BIND_RESULT,
  ACTIVITY_LANDING_BTN_TYPE,
  ACTIVITY_LANDING_POPUP_TYPE,
  reportActivityLandingData,
} from './report';

const COUNT_DOWN = 60;

export default {
  name: 'ActivityLandingBindAccountDialog',
  components: {
    Field,
    [Button.name]: Button,
  },
  props: {
    hashId: {
      type: [Number, String],
      default: '',
    },
  },
  data() {
    return {
      acc: '',
      pass: '',
      mobile: '',
      code: '',
      passType: 0,
      closeImg: `${CDN_URL}/imperialGlory/dialog-mid-close.png`,
      forgetImg: `${CDN_URL}/996/step.png`,
      forgetShow: false,
      accountShow: false,
      validType: 0,
      errorValid: false,
      codeTimer: 0,
      submitLoading: false,
      sendCodeLoading: false,
      codeTimerInterval: null,
    };
  },
  computed: {
    errorFields() {
      if (!this.errorValid) return [];
      const fields = [];
      if (this.validType === 0) {
        if (!this.acc) fields.push('acc');
        if (!this.pass) fields.push('pass');
      } else {
        if (!this.mobile) fields.push('mobile');
        if (!this.code) fields.push('code');
      }
      return fields;
    },
  },
  beforeDestroy() {
    this.clearCodeTimer();
  },
  methods: {
    triggerVisible(flag) {
      this.accountShow = flag;
      if (!flag) {
        this.errorValid = false;
        return;
      }
      this.reportPopupShow();
    },
    onSubmit() {
      if (!this.onValid() || this.submitLoading) return;
      this.submitLoading = true;
      const isPasswordMode = this.validType === 0;
      const popupType = this.getPopupType();
      const api = isPasswordMode ? bindActivityLandingAccount : bindActivityLandingMobile;
      const data = isPasswordMode
        ? {
            hash_id: this.hashId,
            account: this.acc,
            password: this.pass,
          }
        : {
            hash_id: this.hashId,
            mobile: this.mobile,
            code: this.code,
          };

      api(data)
        .then(async (res) => {
          const result = (res && res.data) || {};
          await this.reportBindSubmitResult(ACTIVITY_LANDING_BIND_RESULT.SUCCESS, popupType);
          Toast.success('账号校验成功');
          // 保留接口完整返回，同时平铺 data 字段，方便承接页直接处理后续跳转。
          this.$emit('update', {
            ...(res || {}),
            ...result,
            data: result,
            account: result.landing_bind_account || '',
            mobile: result.mobile || '',
            bind_type: isPasswordMode ? 'account' : 'mobile',
          });
          this.resetForm();
          this.onClose();
        })
        .catch(() => {
          this.reportBindSubmitResult(ACTIVITY_LANDING_BIND_RESULT.FAIL, popupType);
        })
        .finally(() => {
          this.submitLoading = false;
        });
    },
    onSendValidCode() {
      if (!this.hashId) {
        Toast.fail('缺少承接页参数');
        return;
      }
      if (!this.onValidPhone() || this.sendCodeLoading) return;
      this.sendCodeLoading = true;
      sendActivityLandingMobileCode({
        hash_id: this.hashId,
        mobile: this.mobile,
      })
        .then(() => {
          Toast.success('验证码发送成功');
          this.triggerCountdown();
        })
        .finally(() => {
          this.sendCodeLoading = false;
        });
    },
    onValid() {
      this.errorValid = true;
      if (!this.hashId) {
        Toast.fail('缺少承接页参数');
        return false;
      }
      if (this.validType === 0) {
        return !!(this.acc && this.pass);
      }
      return !!(this.mobile && this.code && this.onValidPhone());
    },
    onValidPhone() {
      if (!/^1[3456789]\d{9}$/.test(this.mobile)) {
        Toast.fail('请输入正确的手机号');
        return false;
      }
      return true;
    },
    triggerCountdown() {
      this.clearCodeTimer();
      this.codeTimer = COUNT_DOWN;
      this.codeTimerInterval = setInterval(() => {
        this.codeTimer -= 1;
        if (this.codeTimer <= 0) {
          this.clearCodeTimer();
        }
      }, 1000);
    },
    clearCodeTimer() {
      if (this.codeTimerInterval) {
        clearInterval(this.codeTimerInterval);
        this.codeTimerInterval = null;
      }
      this.codeTimer = 0;
    },
    changeValidType() {
      const btnType = this.validType === 0
        ? ACTIVITY_LANDING_BTN_TYPE.SWITCH_MOBILE
        : ACTIVITY_LANDING_BTN_TYPE.SWITCH_PASSWORD;
      this.reportOtherButtonClick(btnType);
      this.validType = this.validType === 1 ? 0 : 1;
      this.errorValid = false;
      this.reportPopupShow();
    },
    changePasswordType() {
      this.passType = this.passType === 1 ? 0 : 1;
    },
    onShowForget() {
      this.forgetShow = true;
      this.reportOtherButtonClick(ACTIVITY_LANDING_BTN_TYPE.FORGET_ACCOUNT);
    },
    jumpGame() {
      this.reportOtherButtonClick(ACTIVITY_LANDING_BTN_TYPE.NO_ACCOUNT);
      this.onClose();
      this.$router.push({ name: 'gameCenter.home', query: this.$route.query });
    },
    onGoService() {
      this.forgetShow = false;
      this.$router.push({ name: 'service' });
    },
    onClose() {
      this.accountShow = false;
      this.$emit('close');
    },
    resetForm() {
      this.errorValid = false;
      this.acc = '';
      this.pass = '';
      this.mobile = '';
      this.code = '';
      this.clearCodeTimer();
    },
    // 根据当前验证方式换算 popup_type：账号密码=1，手机验证码=2。
    getPopupType() {
      return this.validType === 0
        ? ACTIVITY_LANDING_POPUP_TYPE.ACCOUNT
        : ACTIVITY_LANDING_POPUP_TYPE.MOBILE;
    },
    // data_type=2：绑定弹窗展示上报。
    reportPopupShow(popupType = this.getPopupType()) {
      return reportActivityLandingData({
        data_type: 2,
        hash_id: this.hashId,
        popup_type: popupType,
      });
    },
    // data_type=3：点击“绑定游戏账号”后的绑定结果上报。
    reportBindSubmitResult(bindResult, popupType = this.getPopupType()) {
      return reportActivityLandingData({
        data_type: 3,
        hash_id: this.hashId,
        popup_type: popupType,
        bind_result: bindResult,
        btn_type: ACTIVITY_LANDING_BTN_TYPE.BIND_GAME_ACCOUNT,
      });
    },
    // data_type=4：绑定弹窗内除绑定提交外的其他按钮点击上报。
    reportOtherButtonClick(btnType) {
      return reportActivityLandingData({
        data_type: 4,
        hash_id: this.hashId,
        btn_type: btnType,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 99;
  .content {
    width: 312px;
    height: 291px;
    background: #ffffff;
    border-radius: 8px;
    overflow: hidden;
    margin: 0 auto;
    position: relative;
    .top {
      width: 100%;
      height: 38px;
      text-align: center;
      line-height: 38px;
      color: #fff;
      background: #fe4f4a;
      font-size: 17px;
      font-weight: 700;
    }
    .mid {
      width: 100%;
      height: 100px;
      padding: 0px 20px;
      margin-top: 24px;
    }
    .code-btn {
      min-width: 42px;
      height: 22px;
      padding: 0 4px;
      border: 0;
      border-color: transparent;
      background: transparent;
      color: #ff8401;
      font-size: 12px;
      font-weight: 500;
      line-height: 22px;

      &::before {
        display: none;
      }

      &.van-button--disabled {
        background: transparent;
        color: #ff8401;
        opacity: 1;
      }
    }
    .extra_fn {
      width: 100%;
      font-size: 11px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      color: #3e99d3;
      line-height: 17px;
      padding: 0 32px;
      position: absolute;
      right: 0px;
      bottom: 100px;
    }
    .submit {
      width: 229px;
      height: 39px;
      background: #fe4f4a;
      border-radius: 39px;
      line-height: 39px;
      text-align: center;
      color: #fff;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      font-size: 13px;
      margin: 48px auto 10px auto;
    }
    .submit.disabled {
      opacity: 0.7;
    }
  }
  .close {
    width: 30px;
    display: block;
    margin: 0 auto;
    background-color: #fe4f4a;
    border-radius: 50%;
  }
}

.forgetImg {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 101;
  background-repeat: no-repeat;
  background-size: 100%;
  .close {
    width: 20px;
    display: block;
    margin: 550px auto 24px;
  }
}

.jumpGame {
  width: 200px;
  font-size: 11px;
  font-family: Microsoft YaHei, Microsoft YaHei-Regular;
  font-weight: 400;
  text-decoration: underline;
  text-align: center;
  color: #999999;
  line-height: 17px;
  margin: 0 auto;
}
</style>
